import type { PropsWithChildren } from 'react';
import { useState } from 'react';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { iconSearch } from '@sorare/core/src/atoms/icons/system/iconSearch.ts';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { SearchBarDialog } from '@sorare/core/src/components/navigation/AppNavigation/SearchBar/SearchBarDialog';

export const SearchBarHeaderButton = ({ children }: PropsWithChildren) => {
  const [searchBarOpen, setSearchBarOpen] = useState(false);
  return (
    <>
      <ButtonBase onClick={() => setSearchBarOpen(true)}>
        <Horizontal>
          <IconButton
            size="medium"
            icon={iconSearch}
            color="transparent"
            asSpan
          />
          {children}
        </Horizontal>
      </ButtonBase>
      <SearchBarDialog
        open={searchBarOpen}
        onClose={() => setSearchBarOpen(false)}
      />
    </>
  );
};
